module.exports = __webpack_public_path__ + "img/userLogo10.aac2720d.jpg";